<template>
  <div class="edit-servicestatus">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"><strong>{{ $t("servicestatus") }}</strong></mdb-card-title>
      </mdb-card-header>
      <mdb-card-body v-if="this.loadReady === true">
        <mdb-row class="mt-5">
          <mdb-col md="12">
            <p class="h5">{{ $t("servicestatus_content") }}</p>
          </mdb-col>
          <mdb-col>
            <mdb-input v-model="servicestatus.title" type="text" icon="quote-right"
              :label="$t('servicestatus_title')" />
          </mdb-col>
          <mdb-col>
            <mdb-input v-model="servicestatus.description" type="text" icon="quote-right"
              :label="$t('servicestatus_description')" />
          </mdb-col>
          <mdb-col>
            <mdb-input v-model="status" type="checkbox" id="checkBoxServiceStatus"
              :label="$t('servicestatus_status')" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12">
            <mdb-btn @click="saveServiceStatus" color="indigo" class="white-text" icon="paper-plane">{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";

export default {
  name: "EditServiceStatus",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
  },
  props: {
  },
  methods: {
    loadServiceStatus() {
      this.$notify.info({
        message: this.$t("loading_service_status"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.getservicestatuspath)
        .then((response) => {
          if (response.status == 200) {
            this.servicestatus = response.data;
            this.loadReady = true;
            setTimeout(() => this.fillPage(), 2000);
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    saveServiceStatus() {
      this.postData = {
        id: this.servicestatus.id,
        sessionid: this.$store.getters.getToken,
        title: this.servicestatus.title,
        description: this.servicestatus.description,
        status: this.servicestatus.status,
      };
      this.$http
        .post(this.saveservicestatuspath, JSON.stringify(this.postData))
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_service_status_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          } else {
            this.$notify.error({
              message: this.$t("adding_notification_not_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("adding_notification_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
  computed: {
    status: {
      // getter
      get: function () {
        return this.servicestatus.status === 1 ? true : false;
      },
      // setter
      set: function (newValue) {
        this.servicestatus.status = newValue ? 1 : 0;
      }
    },
  },
  mounted() {
    this.loadServiceStatus();
  },
  data() {
    return {
      saveservicestatuspath: "/1.0/front/servicestatus",
      getservicestatuspath: "/1.0/front/servicestatus",
      servicestatus: null,
      loadReady: false,
    };
  },
};
</script>

<style></style>
